module.exports = __webpack_public_path__ + "media/entities/3001-790fa0b2.png";